import React, { Fragment, useEffect, useState } from 'react';
import { handleSortBy, pColmDisplay, GenerateCertificatePdf, getLastURL, capitalizeFirstLetterWithOnlyLetter, RatingDisplay, CompanyNameDisplay, totalPriceDisplay, PriceCTDisplay, handleSortByAction, totalPriceDisplayforDiscount, totalCarat   , totalPriceDisplayForDiamond , PriceCTDisplayForDiamond , totalPriceDisplayforDiscountForDiamond} from '../../../helper';
import { useSelector, useDispatch } from 'react-redux';
import { url, postPerPage, hrdurl, giaurl } from '../../../config';
import { IMAGES, SEARCH_LIMIT_MSG } from '../../../constants';
import { useHistory } from 'react-router';
import ReactPaginate from "react-paginate";
import { useAlert } from 'react-alert';
import $, { isArray } from 'jquery';
import { getProductsFilterByAscending, getAllProductsCompare, getAllProducts, getUrlToDownloadDocument  , getAllDiamondsProducts , getDiamondsProductsFilterByAscending , getUrlToDownloadDocumentdiamonds , getAllDiamondsProductsCompare} from '../../../actions/productActions';
import { Link } from 'react-router-dom';
import { getAllProductsFilter , getAllDiamondsProductsFilter } from '../../../actions/productActions';
import { diamondsJson, listProductAction } from '../../../utils/json';
import { useLocation } from 'react-router';
import PopupConfirm from '../../layout/PopupConfirm';
import mixpanel from 'mixpanel-browser';
import { FormattedMessage, useIntl } from 'react-intl';
import { DOWNLOAD_FAIL } from '../../../constants/productConstants';
import { comaSeperatedFilter  , comaSeperatedFilterfForSeller} from '../../../helper';
import TableNavbar from './tableNav';

const WhiteDimonds = (props) => {

    const history = useHistory();
    const alert = useAlert();
    const dispatch = useDispatch();
    const location = useLocation();

    const category_slug = getLastURL(location);
    const { products, error, loading } = useSelector(state => state.products);
    const documentDetailState = useSelector(state => state.downloadState);
    const productFilter = useSelector(state => state.DownloadPdfWithFilterState)
    const [postsPerPage, setPostPerPage] = useState(postPerPage);
    const [filterdisplayname, setFilterDisplayName] = useState(<FormattedMessage id="Select Sort Option" />);
    const [search, setSearch] = useState();
    const [selectAllCompare, setSelectAllCompare] = useState(new Array(documentDetailState?.documentDetail?.products?.data).fill(false));
    const [selectedId, setSelectedId] = useState([]);
    const [pageNumber, setPageNumber] = useState(props.pageNumber && props.pageNumber);
    const [activeFilters, setActiveFilters] = useState([]);


    const [popUpLimitTitle, setpopUpLimitTitle] = useState(<FormattedMessage id="Search Limit Finished" />);
    const [popUpLimitMessage, setpopUpLimitMessage] = useState(SEARCH_LIMIT_MSG);
    const [productsData, setproductsData] = useState();
    const [pageCount , setPageCount] = useState(0)

    useEffect(() => {
       sessionStorage.removeItem('selected_products') 
    },[])
    useEffect(() => {
        if (error) {
            alert.error(error);
            return;
        }
        if (documentDetailState?.documentDetail?.pdf_url) {
            if (productFilter?.data?.filter?.seller) {
                sessionStorage.setItem('isSellerFilter', true)
            }
            const link = document.createElement('a');
            link.target = '__blank';
            link.href = documentDetailState?.documentDetail?.pdf_url;
            // link.download = 'diamonds.pdf';
            document.body.appendChild(link);
            link.click();

            //reset state to prevent re-downloading.
            dispatch({
                type: DOWNLOAD_FAIL,
                payload: null
            })
        }
    }, [documentDetailState?.documentDetail])

    const handleResForm = (status) => {
        if (status) {
            $("#dismiss-modal").trigger('click');
            history.push({ pathname: url + '/plan-details' });
        }
    }

    const handlePageChange = ({ selected }) => {
        setPageNumber(selected)
        props.updateResetPageHandler(selected)
        dispatch(getAllDiamondsProducts(category_slug, (selected + 1)));
        // setDisableInitialCallback(0);
    }

    // const pageCount = Math.ceil((products?.products?.total) / postsPerPage);

    const handleAcendingFilter = (value, type, displayname) => {
        setFilterDisplayName(displayname)
        $('.sort_by_list').css({
            display: "none"
        })
        props.tabChangeHandler(1)

        const getSelected  = sessionStorage.getItem('selected_products')
        const payload = { order_by_type: type, order_by_value: value }
        let filter = props?.newactiveFilters ? {...props?.newactiveFilters} : {}
        if(getSelected){
            const productIds = getSelected?.split(',')?.map(Number);
            filter = { compare_product_ids :productIds }
        }
        sessionStorage.setItem('discountDetails', JSON.stringify(payload))
        dispatch(getUrlToDownloadDocumentdiamonds('RESET'));
        dispatch(getDiamondsProductsFilterByAscending(category_slug, value, type , filter))
    }

    const handleListFilter = (value, type, displayname) => {
        $('.sort_by_list').css({
            display: "none"
        })
        if (value == 'pdf') {
            //  setGetPdf(true)
            handleCompare(true, value)
        } else if (value === 'pdf_all' || value === 'excel_all') {
            handleCompare(true, value)
        } else {
            handleCompare(false)
        }
    }

    const handleSearch = (e) => {
        setSearch(e.target.value);
    }

    const handleSearchFilter = (e) => {
        mixpanel.track('Search Diamond')
        if (e.key === 'Enter') {
            dispatch(getAllDiamondsProductsFilter(category_slug, { search: search }));
        }
    }
    const handleSearchIconClick = () => {
        mixpanel.track('Search Diamond');
        dispatch(getAllDiamondsProductsFilter(category_slug, { search: search }));
    };

    const handleSelectCompare = (id, position) => {
        const updatedSelectAllCompare = selectAllCompare && selectAllCompare.map((item, index) => {
            if (index === position) {
                return !item;
            } else {
                return item;
            }
        });
        setSelectAllCompare(updatedSelectAllCompare);

        if (!selectedId?.includes(id)) {
            if (selectedId?.length > 0) {
                setSelectedId([...selectedId, id]);
                const ids = [...selectedId, id]
                sessionStorage.setItem('selected_products', ids);
            }else {
                setSelectedId([id]);
                sessionStorage.setItem('selected_products', [id]);
            }
        } else {
            if (selectedId?.length > 0){
                selectedId?.splice(selectedId?.indexOf(id), 1);
                sessionStorage.setItem('selected_products', selectedId);
            }

        }
    }

const handleCompare = (getPdf, type) => {

        if (type === 'pdf_all' || type === 'excel_all') {
            let filter = props?.newactiveFilters ? {...props?.newactiveFilters} : {}
            const getPdftypes = type == 'pdf_all' ? true : false
            if(selectedId?.length > 0){
            return dispatch(getUrlToDownloadDocumentdiamonds(category_slug, selectedId, getPdftypes,type, filter));
            }else{
                return dispatch(getUrlToDownloadDocumentdiamonds(category_slug, [], getPdftypes, type, filter));
            }
        }

        if (selectedId?.length > 0) {
        let filter = props?.newactiveFilters ? {...props?.newactiveFilters} : {}
            dispatch(getUrlToDownloadDocumentdiamonds(category_slug, selectedId, getPdf , filter));
            setSelectAllCompare(new Array(selectedId?.length)?.fill(true))
        }
         else {
            alert.error('Please select product');
            return;
        }
    }
    const handleCompareRemove = (id) => {
        if (selectedId?.includes(id)) {
            selectedId?.splice(selectedId?.indexOf(id), 1);
        }
        dispatch(getAllDiamondsProductsCompare(category_slug, selectedId))
    }

    const handleDeselectAll = () => {
        setSelectedId([]);
        setSelectAllCompare(new Array(products?.products && products?.products?.data).fill(false))
        dispatch({
            type: DOWNLOAD_FAIL,
            payload: null
        })
        dispatch(getAllDiamondsProductsCompare(category_slug, [], false))

    }

    useEffect(() => {
        if (products?.overlimit) {
            alert.error(products?.message)
            setTimeout(() => {
                window.location.href = url + '/plan-details'
            }, 1000);
            //Your search limit is exhausted. Upgrade and enjoy unlimited search.
            //Arama sınırınız doldu. Yükseltin ve sınırsız aramanın tadını çıkarın.
        }
        if (documentDetailState && documentDetailState?.documentDetail?.is_compare) {
            setproductsData(documentDetailState?.documentDetail?.products?.data)
            setPageCount(Math.ceil((documentDetailState?.documentDetail?.products?.total) / postsPerPage) )
        } else {
            setproductsData(products?.products?.data)
            setPageCount(Math.ceil((products?.products?.total) / postsPerPage) )
        }
    }, [products, documentDetailState])

    products && products?.over_limit &&
        $("#popup-click-confirm").trigger('click')

        //   const handleFilter = (keyToRemove) => {
        //         const updatedFilter = Object.entries(activeFilters).filter(([key]) => key !== keyToRemove).reduce((acc, [key, value]) => {
        //              if(key === 'carat' || key === 'no_BGM') {
        //                 acc[key] = value;
        //                 return acc;
        //              }
        //              if(key == 'is_fancy') {
        //                 acc[key] = value;
        //                 return acc;
        //              }
        //              if(key === 'price') {
        //                 acc[key] = value;
        //                 return acc;
        //              }
        //             acc[key] = value.map(item => item.attribute_id);
        //             return acc;
        //         }, {})
        //         setActiveFilters(updatedFilter);
        //         dispatch(getAllDiamondsProductsFilter(category_slug, updatedFilter));
        //         return
        // };

const handleFilter = (keyToRemove) => {
    const keysToRemove = keyToRemove === 'is_fancy' ? ['is_fancy', 'fancy_color', 'fancy_intensity', 'fancy_overtone'] : [keyToRemove];
    const updatedFilter = Object.entries(activeFilters)
        .filter(([key]) => !keysToRemove.includes(key))
        .reduce((acc, [key, value]) => {
            if (['carat', 'no_BGM', 'is_fancy', 'price'].includes(key)) {
                acc[key] = value;
                    return acc;
            }
            if (['seller'].includes(key)) {
                acc[key] = value.map(item => item?.value);
                    return acc;
            }
             else {
                acc[key] = value.map(item => item.attribute_id);
                    return acc;
                
            }
            return acc;
        }, {});

    setActiveFilters(updatedFilter);
    props?.setNewactiveFilters(updatedFilter)
    dispatch(getAllDiamondsProductsFilter(category_slug, updatedFilter));
};


    useEffect(()=>{
       if(products?.filter && Object.keys(products?.filter).length > 0){
        setActiveFilters(products?.filter)
       }
    },[products?.filter])   
    

    return (
            <Fragment>
                <div className="col-lg-12">
                    <div className="dashboard-content table-filter-area">
                        <div className="filter_search_right">
                            <div className="search_cat_top">
                                {/* <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <Link to={`${url}/advertised-products`}>
                                            <center>
                                                {localStorage.getItem('lang') === 'tr' ? (
                                                    <img src={ad_image1} className="mb-2 w-100" alt="Ad 1" />
                                                ) : (
                                                    <img src={ad_image} className="mb-2 w-100" alt="Ad" />
                                                )}
                                            </center>
                                        </Link>
                                    </div>  
                                </div> */}
                                <div className="row table-filter-row mx-0">
                                    <div className="col-lg-6 col-md-6 col-sm-6 pl-0">
                                        <button className='all-filters-btn' onClick={() => { props?.setShowFilters(!props?.showFilters) }} type='button'><img src={IMAGES.filterIcon} alt="filter-icon" loading="lazy" />
                                            <FormattedMessage
                                                id="addsingleproduct.all-filters"
                                                defaultMessage="All Filters"
                                            />
                                        </button>
                                        {/* <div className="c_box1 c_btn mb-2"> */}
                                        {/* <button className="btn btn-black compare-product-btn" type="button" onClick={handleCompare}><span className="mr-1"><img src={IMAGES.COMPARE_IMG} alt="" /></span> Compare products</button> */}
                                        {/* </div> */}
                                        {/* {
                                            $.map(products && products?.filter, (val, key) => {
                                                const isBgmKey = key === 'no_BGM';
                                                const displayText = isBgmKey && val == "1" ? 'No BGM' : '';
                                                if (isBgmKey) {
                                                    return (
                                                        <div className="s_c" key={key}>
                                                            <p>
                                                                <span className='first-letter'>
                                                                    <b>No BGM:</b> {displayText}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    );
                                                } else {
                                                    return (
                                                        <div className="s_c" key={key}>
                                                            <p>
                                                                <span className='first-letter'>
                                                                    <b>{key}:</b> {val}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    );
                                                }
                                            })
                                        } */}

                                        {
                                            //Kartik's code
                                            products?.filter && Object.entries(products?.filter)?.map(([filterName, filterArr]) => {
                                                if (filterName == 'type') {
                                                        return
                                                      }
                                                 if(filterName == 'carat' || filterName == 'price'){
                                                    return (
                                                    <div className="s_c" key={filterName}>
                                                            <p style={{marginLeft:'10px'}}>
                                                                <span className='first-letter'>
                                                                    <b>{filterName}</b> {filterArr?.from} - {filterArr?.to}
                                                                </span>
                                                                <button
                                                            className='text-black border-0 p-0 bg-none ml-3'
                                                            style={{ outline: 'none' }}
                                                            onClick={() => handleFilter(filterName)}
                                                        >
                                                            <i className='icon-close_1 ml-0'></i>
                                                        </button>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                                if(filterName == 'seller'){
                                                    return (
                                                    <div className="s_c" key={filterName}>
                                                            <p style={{marginLeft:'10px'}}>
                                                                <span className='first-letter'>
                                                                    <b>{filterName}</b> :  {Array.isArray(filterArr) ? comaSeperatedFilterfForSeller(filterArr) : filterArr}
                                                                </span>
                                                                <button
                                                            className='text-black border-0 p-0 bg-none ml-3'
                                                            style={{ outline: 'none' }}
                                                            onClick={() => handleFilter(filterName)}
                                                        >
                                                            <i className='icon-close_1 ml-0'></i>
                                                        </button>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                                if(filterName == 'is_fancy'){
                                                    return (
                                                    <div className="s_c" key={filterName}>
                                                            <p style={{marginLeft:'10px'}}>
                                                                <span className='first-letter'>
                                                                    <b>Fancy</b>: {filterArr == '1' ? 'Yes' : 'No'}
                                                                </span>
                                                                <button
                                                            className='text-black border-0 p-0 bg-none ml-3'
                                                            style={{ outline: 'none' }}
                                                            onClick={() => handleFilter(filterName)}
                                                        >
                                                            <i className='icon-close_1 ml-0'></i>
                                                        </button>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                                 if(filterName == 'no_BGM'){
                                                 return
                                                  }
                                                 else {
                                                    return (
                                                        <div className="s_c" key={filterName}>
                                            
                                                            <p style={{marginLeft:'10px'}}>
                                                                <span className='first-letter'>
                                                                    {filterName}: {Array.isArray(filterArr) ? comaSeperatedFilter(filterArr) : filterArr}
                                                                </span>
                                                                 <button
                                                            className='text-black border-0 p-0 bg-none ml-3'
                                                            style={{ outline: 'none' }}
                                                            onClick={() => handleFilter(filterName)}
                                                        >
                                                            <i className='icon-close_1 ml-0'></i>
                                                        </button>
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6 diamond pr-0">
                                        <div className='d-flex justify-content-end flex-wrap btn-group-row'>
                                            <div className="form-group sort_by_box d-flex justify-content-end">
                                                <p className="sort_b_h text-right" onClick={handleSortByAction}><b className="mr-2"><FormattedMessage id="Select Actions" />:</b><FormattedMessage id="Actions" /> <span className="icon-chevron_down"></span></p>
                                                <div className="sort_by_action">
                                                    <ul>
                                                        {
                                                            listProductAction && listProductAction?.map((data, key) => {
                                                                return (
                                                                    <li className="activessff" onClick={() => handleListFilter(data?.value, data?.type, data?.display_name)} key={key}>{data?.display_name}</li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="form-group sort_by_box d-flex justify-content-end">

                                                <p className="sort_b_h" onClick={handleSortBy}><b>
                                                    <FormattedMessage id="Sort_By" defaultMessage="Sort By" />:</b>{filterdisplayname}<span className="icon-chevron_down"></span></p>
                                                <div className="sort_by_list">
                                                    <ul>
                                                        {
                                                            diamondsJson && diamondsJson?.map((data, key) => {
                                                                if(!['views_count', 'favorite_count'].includes(data?.value)){
                                                                return (
                                                                    <li className="activess" onClick={() => handleAcendingFilter(data?.value, data?.type, data?.display_name)} key={key}>{data?.display_name}</li>
                                                                )
                                                                }
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/* {
                                    products && products.pdf_url && products.pdf_url.length > 0 &&
                                        <div className="row pdf_download_row text-right">
                                            
                                            <a href={products.pdf_url} target="_blank" className="not_a" id="download-pdf"  download={true}>Click here for download <img src={IMAGES.DOWNLOAD_SVG} /></a>
                                    
                                        </div>
                            } */}

                            </div>
                            <div className="form-group seach_filter row justify-content-end">
                                <div className="col-xl-8 col-lg-6 col-md-6 col-sm-6">
                                    <TableNavbar products={products} />
                                </div>

                                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 text-right">
                                    <div className='position-relative d-inline-block mw-100'>
                                        <input
                                            type="text"
                                            value={search}
                                            onKeyPress={(e) => handleSearchFilter(e)}
                                            onChange={handleSearch}
                                            className="form-control"
                                            placeholder={useIntl().formatMessage({ id: 'SearchBySeller' })}
                                        />
                                        <span className="icon-search_1  input_icon" onClick={handleSearchIconClick} style={{ cursor: 'pointer' }}></span>
                                    </div>
                                </div>
                            </div>
                            <div className="filter_table">
                                <div className="tbles">
                                    {(loading || documentDetailState?.loading) ? <div className="loader-line"></div> : ""}
                                    <table width="100%">
                                        <thead>
                                            <tr>
                                                <th width="5%"></th>
                                                <th><FormattedMessage id="Seller" defaultMessage="Seller" /></th>
                                                <th><FormattedMessage id="Rating" defaultMessage="Rating" /></th>
                                                <th><FormattedMessage id="Shape" defaultMessage="Shape" /></th>
                                                <th><FormattedMessage id="addsingleproduct.carat" defaultMessage="Carat" /></th>
                                                {
                                                    products && products?.is_fancy == 1 ?
                                                        <Fragment>
                                                            <th><FormattedMessage id="Intensity" defaultMessage="Intensity" /></th>
                                                            <th><FormattedMessage id="Overtone" defaultMessage="Overtone" /></th>
                                                        </Fragment> :
                                                        <Fragment>
                                                        </Fragment>
                                                }
                                                <th><FormattedMessage id="addsingleproduct.color" defaultMessage="Color" /></th>
                                                <th><FormattedMessage id="addsingleproduct.clarity" defaultMessage="Clarity" /></th>
                                                <th><FormattedMessage id="addsingleproduct.cut" defaultMessage="Cut" /></th>
                                                <th><FormattedMessage id="addsingleproduct.pol" defaultMessage="Pol" /></th>
                                                <th><FormattedMessage id="addsingleproduct.sym" defaultMessage="Sym" /></th>
                                                <th><FormattedMessage id="addsingleproduct.Fluor" defaultMessage="Fluor" /></th>
                                                <th><FormattedMessage id="addsingleproduct.Cert" defaultMessage="Cert" /></th>
                                                <th><FormattedMessage id="addsingleproduct.milky" defaultMessage="Milky" /></th>
                                                <th><FormattedMessage id="addsingleproduct.bgm" defaultMessage="BGM" /></th>
                                                <th><FormattedMessage id="addsingleproduct.media" defaultMessage="Media" /></th>
                                                <th><FormattedMessage id="addsingleproduct.status" defaultMessage="status" /></th>

                                                {
                                                    products && products?.is_fancy == 0 ?
                                                        <Fragment>
                                                            <th><FormattedMessage id="addsingleproduct.discount" defaultMessage="discount" /></th>
                                                        </Fragment> :
                                                        <Fragment>
                                                        </Fragment>
                                                }
                                                <th><FormattedMessage id="addsingleproduct.price_ct_d" /></th>
                                                <th><FormattedMessage id="addsingleproduct.price_total_d" /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                productsData?.length > 0 ?
                                                    productsData?.map((data, key) => {
                                                        return (
                                                            <tr key={key}>
                                                                <td>
                                                                    <div className="form-group mb-0 mini checks inss">
                                                                        <input
                                                                            type="checkbox"
                                                                            id={'p' + data?.id}
                                                                            className="checkbox"
                                                                            name="check"
                                                                            checked={selectAllCompare[key]}
                                                                            onChange={() => handleSelectCompare(data?.id, key)}
                                                                        />
                                                                        <label htmlFor={'p' + data?.id}></label>
                                                                    </div>
                                                                </td>
                                                                <td  >
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        <span>{CompanyNameDisplay(data)}</span>&nbsp;{"\n"} <br />

                                                                    </Link>
                                                                </td>
                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        <i style={{ color: "#003B75" }} className="fa fa-star mr-1"></i>
                                                                        {RatingDisplay('list', data.average_rating, data.total_rating)}
                                                                    </Link>
                                                                </td>
                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        {pColmDisplay(data, 'a_shape')}
                                                                    </Link>
                                                                </td>
                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">{data && data.carat && totalCarat(data)}
                                                                    </Link>
                                                                </td>
                                                                {
                                                                    products && products?.is_fancy == 1 ?
                                                                        <>
                                                                            <td>
                                                                                <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                                    {pColmDisplay(data, 'a_fancy_intensity')}
                                                                                </Link>
                                                                            </td>
                                                                            <td>
                                                                                <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                                    {pColmDisplay(data, 'a_fancy_overtone')}
                                                                                </Link>
                                                                            </td>
                                                                            <td>
                                                                                <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                                    {pColmDisplay(data, 'a_fancy_color')}
                                                                                </Link>
                                                                            </td>
                                                                        </>
                                                                        :
                                                                        <td>
                                                                            <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                                {pColmDisplay(data, 'a_color')}
                                                                            </Link>
                                                                        </td>

                                                                }
                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        {pColmDisplay(data, 'a_clarity')}
                                                                    </Link>
                                                                </td>
                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        {data && data.a_cut && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_cut'))}
                                                                    </Link>
                                                                </td>
                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        {data && data.a_polish && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_polish'))}
                                                                    </Link>
                                                                </td>

                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        {data && data.a_symmetry && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_symmetry'))}
                                                                    </Link>
                                                                </td>
                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        {data && data.a_fluorescence && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'a_fluorescence'))}
                                                                    </Link>
                                                                </td>

                                                                {
                                                                    (() => {
                                                                        if (data && data?.certificate_url) {
                                                                            return <td><a href={GenerateCertificatePdf(data?.certificate_url)} target={GenerateCertificatePdf(data?.certificate_url)}>{pColmDisplay(data, 'a_certificate')}</a></td>
                                                                        }
                                                                        else if (data.certificate == "422" && pColmDisplay(data, 'a_certificate') == "HRD") {
                                                                            return <td><a href={hrdurl + data.certificate_number} target="_blank">{pColmDisplay(data, 'a_certificate')}</a></td>
                                                                        } else if (data.certificate == "25" && pColmDisplay(data, 'a_certificate') == "GIA") {
                                                                            return <td><a href={giaurl + data.certificate_number} target="_blank">{pColmDisplay(data, 'a_certificate')}</a></td>
                                                                        } else {
                                                                            return <td>{pColmDisplay(data, 'a_certificate')}</td>
                                                                        }
                                                                    })()
                                                                }

                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        {/* {pColmDisplay(data.milky.display_name, 'milky')} */}
                                                                        {data && data.milky && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'milky'))}

                                                                    </Link>
                                                                </td>

                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        {/* {pColmDisplay(data && data.bgm,  'bgm')} */}
                                                                        {data.bgm == 1 ? 'No' : "Yes"}
                                                                    </Link>
                                                                </td>

                                                                <td>
                                                                    <Link className='table-icons-wrap' to={url + `/details/diamonds/${data?.id}`} target="_blank">
                                                                        <img className={data?.certificate_number ? '' : "img-disabled"} src={IMAGES.docIcon} alt="doc-icon" loading="lazy" />
                                                                        <img className={data?.has_image == '1' ? "" : "img-disabled"} src={IMAGES.imgIcon} alt="image-icon" loading="lazy" />
                                                                        <img className={(data?.has_video == '1' || data?.diamond_3d_link)  ? "" : 'img-disabled'} src={IMAGES.playIcon} alt="video-icon"  loading="lazy"/>
                                                                    </Link>
                                                                </td>

                                                                <td>
                                                                    <Link to={url + `/details/diamonds/${data?.id}`} target="_blank" className="not_a">
                                                                        {data && data.availability_status && capitalizeFirstLetterWithOnlyLetter(pColmDisplay(data, 'availability_status'))}
                                                                    </Link>
                                                                </td>
                                                                {/* {data && data?.certificate_url ?
                                                                    <td><a href={GenerateCertificatePdf(data?.certificate_url)} target={GenerateCertificatePdf(data?.certificate_url)}>{pColmDisplay(data, 'a_certificate')}</a></td>
                                                                    :
                                                                    <td><a href={hrdurl+data.certificate_number} target="_blank">{pColmDisplay(data, 'a_certificate')}</a></td>
                                                                } */}

                                                                {
                                                                    products && products?.is_fancy == 0 ?
                                                                        <Fragment>
                                                                            <td>
                                                                                <Link
                                                                                    to={url + `/details/diamonds/${data?.id}`}
                                                                                    target="_blank"
                                                                                    className="not_a">
                                                                                    {data && data?.updated_discount  ? totalPriceDisplayforDiscountForDiamond(data) : "--"}
                                                                                </Link>
                                                                            </td>
                                                                        </Fragment> :
                                                                        <Fragment>
                                                                        </Fragment>
                                                                }

                                                                <td>
                                                                    <Link
                                                                        to={url + `/details/diamonds/${data?.id}`}
                                                                        target="_blank"
                                                                        className="not_a">
                                                                        {PriceCTDisplayForDiamond(data)}
                                                                    </Link>
                                                                </td>
                                                                <td>
                                                                    <Link
                                                                        to={url + `/details/diamonds/${data?.id}`}
                                                                        target="_blank"
                                                                        className="not_a">
                                                                        {totalPriceDisplayForDiamond(data)}
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <th colSpan="25"><FormattedMessage id="ProductNotFound" defaultMessage="Product not Found" /></th>
                                                    </tr>
                                            }
                                        </tbody>


                                    </table>
                                </div>


                                <div className='row my-4'>
                                    <div className='col-sm-7 col-lg-8'>
                                        <TableNavbar products={products} />
                                    </div>
                                    <div className='col-sm-5 col-lg-4'>
                                        <div className="table_pagination">
                                            <ReactPaginate
                                                previousLabel={<i className="icon icon-chevron_gray-left"></i>}
                                                nextLabel={<i className="icon icon-chevron_black"></i>}
                                                pageCount={pageCount}
                                                onPageChange={handlePageChange}
                                                containerClassName={"paginationBttns"}
                                                previousLinkClassName={"previousBttn"}
                                                nextLinkClassName={"nextBttn"}
                                                disabledClassName={"paginationDisabled"}
                                                activeClassName={"paginationActive"}
                                                forcePage={props?.pageReset}
                                                //initialPage={pageNumber && pageNumber}
                                                //renderOnZeroPageCount={null}
                                                disableInitialCallback={true}
                                            />
                                        </div>
                                    </div>
                                </div>



                                {/* <div className="compare_list">
                                    {
                                        documentDetailState?.documentDetail && documentDetailState?.documentDetail?.is_compare ?
                                            documentDetailState?.documentDetail && documentDetailState?.documentDetail?.products?.data?.map((data, key) => {
                                                return (
                                                    <div className="c_box1">
                                                        <i className="icon_b icon-minus" onClick={() => handleCompareRemove(data?.id, key)}></i>
                                                        <p className="font-14 black-3B "><b>{data.company_name}</b>${totalPriceDisplay(data)}</p>
                                                    </div>
                                                )
                                            })
                                            :
                                            null
                                    }
                                    {
                                        documentDetailState?.documentDetail && documentDetailState?.documentDetail?.is_compare
                                            ?
                                            <div className="c_box1">
                                                <i className="icon_black icon-minus" style={{ cursor: 'pointer' }} onClick={handleDeselectAll}></i>
                                                <p className="font-14 black-3B">Deselect all</p>
                                            </div>
                                            :
                                            null
                                    }

                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            {
                <PopupConfirm
                    message={popUpLimitMessage}
                    title={popUpLimitTitle}
                    handleResForm={handleResForm}
                />
            }
            </Fragment>

    )
}

export default WhiteDimonds